import React from 'react';
import { render } from 'react-dom';

import PackageListing from '../react/PackageListing';

export default class PackageListingRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { api, model } = this.context.dataset;
    if (!api || !model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<PackageListing {...jsonModel} apiUrl={api} />, this.context);
  }
}
